import { Container, Title, Text, Button, Group, Image } from '@mantine/core';
import classes from './HeroBullets.module.css';

export function HeroBullets() {
  // const features = data.map((feature) => (
  //   <div key={feature.title} className={classes.feature}>
  //     <div className={classes.overlay} />
  //     <div className={classes.content}>
  //       <div className={classes.icon} style={{ fontSize: '2rem' }}>
  //         {feature.icon}
  //       </div>
  //       <Text size="lg" fw={500} mt="md">
  //         {feature.title}
  //       </Text>
  //       <Text c="dimmed" size="sm" mt="sm">
  //         {feature.description}
  //       </Text>
  //     </div>
  //   </div>
  // ));

  return (
    <div className={classes.wrapper}>
      <Container size="lg">
        <div className={classes.inner}>
          <div className={classes.content}>
            <div className={classes.heroImage}>
              <Image
                src="/images/hero-image.jpg"
                alt="SmartMenu Hero Image"
                radius="md"
              />
            </div>

            <Title className={classes.title}>
            人材不足を「AIメニュー」で解決！
            </Title>

            <Text className={classes.description} color="dimmed">
            「英語が話せるスタッフが足りなくて、外国人のお客様に対応できない…」そんなお悩みも、「AIメニュー」の【SmartMenu】で簡単に解決できます！

            </Text>

            <Group className={classes.controls}>
              <Button 
                variant="filled"
                color="green"
                size="lg"
                className={classes.control}
                onClick={() => {
                  const contactForm = document.getElementById('contact-form');
                  if (contactForm) {
                    contactForm.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                    });
                  }
                }}
              > 
                お問い合わせ
              </Button>



              <Button
                size="lg"
                variant="default"
                className={classes.control}
                component="a"
                href="https://smartmenu.kosho.co/menus/a70b1d17-ffe1-422f-b3ef-acfd9acef74a"
                target="_blank"
                rel="noopener noreferrer"
              >
                デモを見る
              </Button>
            </Group>

          </div>

          {/* <div className={classes.features}>{features}</div> */}
        </div>
      </Container>
    </div>
  );
} 